import React, { Component } from "react";
import { connect } from "react-redux";
import ViewQrcode from "../components/viewQrcode";

import { close_snack_bar } from "../../common/snackbar/action";

export class Controller extends Component {
  render() {
    return <ViewQrcode {...this.props} />;
  }
}
export const mapStateToProps = (store) => {
  return {
    login: store.login,
    loader: store.loader,
    snackbar: store.snackbar,
    QrCode: store.QrCode,
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    close_snack_bar: () => {
      dispatch(close_snack_bar());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Controller);
